import { render, staticRenderFns } from "./receivepaymentDetail.vue?vue&type=template&id=780fc305"
import script from "./receivepaymentDetail.vue?vue&type=script&lang=js"
export * from "./receivepaymentDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports